import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearAccessDenied } from "../../../redux/actions/accessActions";
import "../../css/AuthModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

interface Props {
	onLoginClick: () => void;
}

const AccessDeniedModal: React.FC<Props> = ({ onLoginClick }) => {
	const dispatch = useDispatch();

    useEffect(() => {
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = "auto";
		};
	}, []);

	const handleLogin = () => {
		dispatch(clearAccessDenied());
		onLoginClick(); // Abre el modal de login
	};

	const handleClose = () => {
		dispatch(clearAccessDenied());
	};

	const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.target === e.currentTarget) {
			handleClose();
		}
	};

	return (
		<div className="modal-overlay" onClick={handleOverlayClick}>
			<div className="modal-box">
				<FontAwesomeIcon icon={faXmark} onClick={handleClose} className="close-btn" />
				<h3>Acceso denegado</h3>
				<p>Necesitas iniciar sesión para acceder a esta sección.</p>
				<button onClick={handleLogin}>Iniciar sesión</button>
			</div>
		</div>
	);
};

export default AccessDeniedModal;
